export default __webpack_public_path__ + "static/media/mountain-2.781c18f2.png";